import imgSrc from '~/assets/img/direction-icons/qa.png';
import { LandingImagePayload } from '~/common/types/types';

const landingPayload: LandingImagePayload = {
  title: 'technology.qa.landing.title',
  subtitleTop: 'technology.qa.landing.subtitleTop',
  subtitleBottom: null,
  description: 'technology.qa.landing.description',
  items: [
    {
      icon: 'time',
      title: 'technology.qa.landing.item0',
    },

    {
      icon: 'coin',
      title: 'technology.qa.landing.item1',
    },
    {
      icon: 'web',
      title: 'technology.qa.landing.item2',
    },
  ],
  imgSrc,
  registrationBtn: 'registration.applyNow',
  registrationEnd: 'registration.end',
};

export { landingPayload };
